export const handleOnKeyDown = (
  e: React.KeyboardEvent<HTMLSpanElement>,
  cb: (...args: any) => void
) => {
  if (e.key === 'Enter') {
    cb();
  }
};
